import { PasswordInput, type PasswordInputProps } from '@mantine/core';
import type { ChangeEvent } from 'react';
import type { Except, Merge, SetRequired } from 'type-fest';
import type { Controlled_CommonInputProps } from './types';

export type Controlled_SecretInputProps = Merge<
    Except<SetRequired<PasswordInputProps, 'readOnly'>, 'w'>,
    Except<Controlled_CommonInputProps<false, string>, 'nullable'>
>;

export const Controlled_SecretInput = ({
    onChange,
    ...props
}: Controlled_SecretInputProps) => {
    const handleChange =
        onChange ?
            (event: ChangeEvent<HTMLInputElement>) =>
                onChange(event.currentTarget.value)
        :   undefined;

    return (
        <PasswordInput
            {...props}
            onChange={handleChange}
            w={'100%'}
        />
    );
};
